const LOCALE_STORAGE_KEY = "app-locale";
const SUPPORTED = ["ro", "en", "ru"];
const FALLBACK = "ro";

const browserLocale = () => {
  if (typeof navigator === "undefined" || !navigator.language) {
    return null;
  }
  return navigator.language.toLowerCase();
};

export const mapToSupportedLocale = (localeCandidate) => {
  if (!localeCandidate) return null;
  const base = localeCandidate.split("-")[0];
  if (SUPPORTED.includes(localeCandidate)) return localeCandidate;
  if (SUPPORTED.includes(base)) return base;
  return null;
};

export const ensureSupportedLocale = (localeCandidate) =>
  mapToSupportedLocale(localeCandidate) || FALLBACK;

export const detectInitialLocale = () => {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored) {
    return ensureSupportedLocale(stored);
  }
  const fromBrowser = mapToSupportedLocale(browserLocale());
  return fromBrowser || FALLBACK;
};

export const persistLocale = (locale) => {
  if (locale) {
    localStorage.setItem(LOCALE_STORAGE_KEY, ensureSupportedLocale(locale));
  }
};

export const getSupportedLocales = () => [...SUPPORTED];
